import { Card, CardContent } from "@/components/ui/card";

interface AccessControlContainerProps {
  children?: React.ReactNode;
  message?: string;
}

export const AccessControlContainer = ({ children, message }: AccessControlContainerProps) => {
  if (message) {
    return (
      <Card>
        <CardContent className="py-4">
          <p className="text-center text-muted-foreground">
            {message}
          </p>
        </CardContent>
      </Card>
    );
  }

  return <>{children}</>;
};